import OwnerFormSection from "@rf/property/module/components/property-form/septions/property-steps/location-step/OwnerFormSection";
import { Divider, Grid } from "@mui/material";
import { memo } from "react";
import MxMapLayout from "@rf-l1/map-v2/context/MxMapLayout";
import MxFormL3CityField from "@rf-l3/form/MxFormL3CityField";
import MxFormL3InputField from "@rf-l3/form/MxFormL3InputField";
import LocationFormSection from "./LocationFormSection";

const LocationStep = () => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <OwnerFormSection />
      </Grid>
      <Grid item xs={12} mx={2} my={1}>
        <Divider orientation="horizontal" />
      </Grid>
      <Grid item xs={12}>
        <LocationFormSection />
      </Grid>
    </Grid>
  );
};

export default memo(LocationStep);
